import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

interface GenerateConfirmDialogProps {
  open: boolean;
  appraiseeName: string;
  assignmentId: string;
  collatorName: string;
  isGenerating: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function GenerateConfirmDialog({
  open,
  appraiseeName,
  assignmentId,
  collatorName,
  isGenerating,
  onClose,
  onConfirm,
}: GenerateConfirmDialogProps) {
  // Generation is synchronous and can take a few seconds (Qualtrics survey + notification emails),
  // so while it runs the dialog is locked (no backdrop/Escape dismissal) and both actions disabled.
  return (
    <Dialog
      open={open}
      onClose={isGenerating ? undefined : onClose}
      aria-labelledby="generate-job-end-title"
    >
      <DialogTitle id="generate-job-end-title">Generate Job End?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to generate a Job End for {appraiseeName} for assignment{' '}
          {assignmentId} where the Collator is {collatorName}?
        </DialogContentText>
        {isGenerating && (
          <Box
            sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mt: 2 }}
            aria-live="polite"
          >
            <CircularProgress size={20} aria-hidden />
            <DialogContentText sx={{ m: 0 }}>
              This can take a few seconds while the survey and notifications are created.
            </DialogContentText>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" disabled={isGenerating}>
          No
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="secondary"
          disabled={isGenerating}
          aria-busy={isGenerating}
          startIcon={isGenerating ? <CircularProgress size={18} color="inherit" /> : undefined}
        >
          {isGenerating ? 'Generating Job End…' : 'Yes'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default GenerateConfirmDialog;
